import { Flex, styled, StyleSystemProps } from '@withjoy/joykit';

export const DashboardAccordionWrapper = styled(Flex)``;
const dashboardAccordionWrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  rowGap: 3,
  alignItems: 'center',
  width: '100%'
};

export const styles = {
  DashboardAccordionWrapper: dashboardAccordionWrapperStyles
};
